<template>
  <div class="m-table-admin m-table--large">
    <table>
      <thead>
        <tr class="m-table-admin__row">
          <th class="m-table-admin__col">{{ $t('business-list-business-label') }}</th>
          <th class="m-table-admin__col">{{ $t('business-list-entrepeneurs-label') }}</th>
          <th class="m-table-admin__col">{{ $t('business-list-register-date-label') }}</th>
          <th class="m-table-admin__col">{{ $t('business-list-phone-number-label') }}</th>
          <th class="m-table-admin__col m-table-admin__col--right">{{ $t('business-list-email-label') }}</th>
        </tr>
      </thead>
      <gathering-business-list-item
        v-for="business in orderedGatherings"
        :key="business.Id"
        :business="business"
        :entrepreneurs="entrepreneurs"
        :users="users"
        @removeBusiness="$emit('removeBusiness', business.Id)"
      />
    </table>
  </div>
</template>

<script>
import GatheringBusinessListItem from '@/components/dashboard/gathering/gathering-business-list-item'

export default {
  components: {
    GatheringBusinessListItem
  },
  props: {
    value: {
      type: Array,
      required: true
    },
    entrepreneurs: {
      type: Array,
      required: true
    },
    users: {
      type: Array,
      required: true
    }
  },
  computed: {
    orderedGatherings: function() {
      return this.value.slice(0).sort((x, y) => {
        return new Date(y.GatheringRegistrationDate) - new Date(x.GatheringRegistrationDate)
      })
    }
  }
}
</script>

<style lang="scss">
.m-table-admin {
  display: block;
  overflow-x: auto;
  margin-bottom: $margin-base;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: scrollbar;

  table {
    font-size: $font-size-base;
    max-width: 100%;
    width: 100%;
  }

  tr {
    border-top: 0;
  }

  th,
  td {
    padding: 16px;
    min-width: 140px;
    vertical-align: top;
  }

  thead {
    border-bottom: 1px solid $border-color;
    font-weight: bolder;

    th {
      vertical-align: bottom;
    }
  }

  tbody {
    border-top: 1px solid $border-color;

    &:hover {
      background-color: rgba($border-color, 0.3);
    }
  }

  &__row {
    &--btn {
      td {
        padding-top: 0;
        padding-bottom: 6px;
      }
    }
  }

  &__col {
    &--right {
      text-align: right;
    }
  }
}

.dropdown-item {
  white-space: nowrap;
}

.context-menu-aligned {
  float: right;
  margin: 0 0 10px 10px;
}

.a-btn-edit {
  @include btn-default-properties;
  width: 40px;
  flex-shrink: 0;
  img {
    vertical-align: baseline;
  }
}

.business-list {
  &__name {
    align-items: center;
    display: flex;
  }

  &__picture {
    border-radius: 50%;
    height: 60px;
    margin-right: 35px;
    overflow: hidden;
    position: relative;
    width: 60px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    flex-shrink: 0;

    &-image {
      display: block;
      left: 50%;
      min-height: 100%;
      min-width: 100%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  &__actions {
    & > dropdown-menu,
    & > a,
    & > button {
      margin: 0 0 10px 10px;
    }
  }
}
</style>
